<template>
  <div>
    <login-desktop v-if="screenType === 'desktop'"></login-desktop>
    <login-mobile v-if="screenType === 'mobile'"></login-mobile>
    <login-tablet v-if="screenType === 'tablet'"></login-tablet>
  </div>
</template>

<script>
import LoginDesktop from "@/components/Pages/Desktop/Auth/LoginDesktop";
import LoginMobile from "@/components/Pages/Mobile/Auth/LoginMobile";
import LoginTablet from "@/components/Pages/Tablet/Auth/LoginTablet";

export default {
  name: "LoginMain",
  components: {LoginMobile, LoginDesktop, LoginTablet},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>